<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">Export Freezer Request</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <CRow>
          <CCol sm="3">
            <div class="form-group">
              <label for="date_order">Date Requested</label>
              <vc-date-picker
                mode="range"
                id="date"
                :input-props="{
                  class: 'form-control',
                  placeholder: 'Tanggal Pengajuan',
                  required: '',
                  readonly: '',
                }"
                v-model="myDate"
              ></vc-date-picker>
            </div>
          </CCol>
        </CRow>
        <br />
        <div class="col-lg-3">
          <CButton type="button" size="sm" @click="downloadfile" color="info">
            <i class="fa fa-save"></i> Download
          </CButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";
import * as moment from "moment";

export default {
  name: "order_history",
  components: {
    loading,
    ModelSelect,
  },
  data() {
    return {
      month: [
        { value: "01", text: "January" },
        { value: "02", text: "February" },
        { value: "03", text: "March" },
        { value: "04", text: "April" },
        { value: "05", text: "May" },
        { value: "06", text: "June" },
        { value: "07", text: "July" },
        { value: "08", text: "August" },
        { value: "09", text: "September" },
        { value: "10", text: "October" },
        { value: "11", text: "November" },
        { value: "12", text: "December" },
      ],
      year: [
        { value: "2019", text: "2019" },
        { value: "2020", text: "2020" },
      ],
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MM"),
      loading: false,
      myDate: null,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.loading = false;
    },
    downloadfile: function () {
      if (confirm("Are You Sure?")) {
        //this.loading = true;
        if (this.myDate === null) {
          alert("Tanggal Harus di pilih");
        } else {
          let start = moment(this.myDate.start).format("YYYY-MM-DD");
          let end = moment(this.myDate.end).format("YYYY-MM-DD");
          this.loading = true;
          this.axios({
            url: "console/export/freezer_request/all/" + start + "/" + end + "/",
            method: "GET",
            responseType: "blob", //before "blob"
          })
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "freezer_request.xlsx");
              document.body.appendChild(link);
              link.click();
            })
            .catch((error) => {
              if (error.response.status === 401) {
                this.expired(error, "");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
